"use client";

import React from "react";
import aboutImage from "../assets/images/dubai1.webp";
import aboutImage2 from "../assets/images/dubai2.webp";

function AboutVoyage() {
  return (
    <section className="w-full bg-[#FEFEFE] px-5 py-6 sm:px-8 lg:px-12 md:py-24">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 lg:grid-cols-2 lg:gap-20">
        {/* LEFT IMAGE AREA */}
        <div className="relative mx-auto h-[470px] w-full max-w-[620px] sm:h-[540px] lg:h-[570px]">
          {/* GREEN BACK ACCENT */}
          {/* <div className="absolute bottom-[55px] left-0 h-[150px] w-[28px] bg-[#97BF49] sm:h-[170px] sm:w-[32px]" /> */}

          {/* MAIN IMAGE */}
          <div className="absolute left-[20px] top-0 h-[88%] w-[76%] overflow-hidden shadow-[0_20px_45px_rgba(18,52,74,0.12)] sm:left-[30px]">
            <img
              src={aboutImage}
              alt="Voyage travel"
              className="h-full w-full object-cover transition-transform duration-700 hover:scale-105 rounded-lg"
            />

            {/* IMAGE DARK OVERLAY */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#12344A]/35 via-transparent to-transparent" />

            {/* IMAGE TITLE */}
            <div className="absolute left-7 top-7 sm:left-9 sm:top-9">
              <span className="block text-[24px] font-extrabold uppercase leading-[1] tracking-[-0.5px] text-white sm:text-[30px]">
                About
              </span>

              <span className="mt-1 block text-[24px] font-extrabold uppercase leading-[1] tracking-[-0.5px] text-white sm:text-[30px]">
                Voyage Plus
              </span>

              <div className="mt-4 h-[3px] w-16 bg-[#97BF49] sm:w-20" />
            </div>
          </div>

          {/* SECOND IMAGE */}
          <div className="absolute bottom-[20px] right-[5px] z-20 h-[54%] w-[60%] overflow-hidden  sm:right-0">
            <img
              src={aboutImage2}
              alt="Voyage travel experience"
              className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
            />
          </div>

          {/* GREEN FRAME */}
          <div className="absolute bottom-[5px] right-[-8px] z-10 h-[55%] w-[60%] border-[14px] border-[#97BF49] sm:right-[-12px] sm:border-[16px]" />
        </div>

        {/* RIGHT CONTENT */}
        <div className="max-w-[590px]">
          {/* LABEL */}
          <div className=" flex items-center gap-4">
           <span className="mb-4 inline-block text-base font-bold tracking-[0.2em] text-[#007FC0]">
                About Us
              </span>
          </div>

          {/* HEADING */}
          <h2 className="m-0 text-[25px] font-semibold leading-[1.1] tracking-[0.2px] text-[#12344A] sm:text-[44px] md:text-[48px] lg:text-[50px]">
            Built on Trust.
            <br />
            Driven by Experience.
            <br />
            Focused on You.
          </h2>

          {/* FIRST PARAGRAPH */}
          <p className="md:mt-7 mt-3 text-[15px] font-medium leading-[1.8] text-[#536B7A] sm:text-lg">
            <span className="font-medium text-[#019EE7]">
              Voyage Plus Travel LLC
            </span>{" "}
            is a specialized outbound travel division dedicated to creating
            seamless and memorable travel experiences for individuals, families,
            and corporate clients.
          </p>

          <p className="md:mt-5 mt-2 text-[15px] font-medium leading-[1.8] text-[#536B7A] sm:text-lg">
            Built on years of industry expertise, we combine reliability,
            personalized service, and professional travel solutions to make
            every journey simple, comfortable, and memorable.
          </p>

          {/* BUTTON */}
          <div className="mt-8">
            <a
              href="/about"
              className="group inline-flex items-center gap-4 rounded-lg bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6] px-6 py-3 text-[13px] font-bold tracking-[0.6px] text-white shadow-[0_10px_25px_rgba(1,158,231,0.20)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#12344A] hover:shadow-[0_15px_30px_rgba(18,52,74,0.20)]"
            >
              <span>LEARN MORE</span>

              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-white/15 transition-all duration-300 group-hover:translate-x-1">
                <i className="las la-arrow-right text-[16px]" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutVoyage;
